import PDFLoader from "./components/PDFLoader";

export default function NewsLetterListPage() {
    const newsLetters = [
      "/pdfs/26-10-25.pdf",
      "/pdfs/26-10-18.pdf",
      "/pdfs/26-10-11.pdf",
      "/pdfs/26-10-04.pdf",
    ];

    return (
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold text-center my-6">Weekly News Letters</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            {newsLetters.map((src, index) => (
              <div key={index} className="border p-4 rounded-lg shadow-lg">
                <h2 className="text-xl font-semibold mb-2">Newsletter for {src.split("/").pop().replace(".pdf", "")}</h2>
                <PDFLoader src={src} />
              </div>
            ))}
          </div>
        </div>
      );
}